import { AuthErrorKeys } from '../entity/AuthErrorKeys';
export function checkUserAuthSessionUsecaseFactory(deps) {
    return async () => {
        let userAuthToken;
        try {
            userAuthToken = await deps.authRepository.getUserAuth0Token();
        }
        catch (auth0Error) {
            if (auth0Error.error === 'login_required') {
                throw new Error(AuthErrorKeys.IS_NOT_AUTHENTICATED);
            }
            else {
                throw auth0Error;
            }
        }
        const signupScopes = deps.signupScopes || [];
        if (userAuthToken.scopes.length === signupScopes.length) {
            if (!signupScopes.every((scope) => userAuthToken.scopes.includes(scope))) {
                throw new Error(AuthErrorKeys.INVALID_SCOPE);
            }
        }
        else {
            const requiredScopes = deps.requiredScopes || [];
            if (!requiredScopes.every((scope) => userAuthToken.scopes.includes(scope))) {
                throw new Error(AuthErrorKeys.INVALID_SCOPE);
            }
        }
    };
}
//# sourceMappingURL=check-user-auth-session.usecase.js.map